// extracted by mini-css-extract-plugin
export default {"container":"DisplayQuotes_container__k2Aky","quote":"DisplayQuotes_quote__XUA-e","button":"DisplayQuotes_button__VWk+v"};